import * as actions from '../actions'

const firstDashCampaigns = (state = {}, action) => {
  switch (action.type) {
    case actions.GET_PROMOTIONAL_CARDS.IN_PROGRESS:
      return { ...state }
    case actions.GET_PROMOTIONAL_CARDS.SUCCESS:
      return { ...state, ...action.payload }
    case actions.GET_PROMOTIONAL_CARDS.FAIL:
      return { ...state }
    default:
      return state
  }
}

export default firstDashCampaigns
